import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';

const EMPTY_SKILL_NUDGES = [];

export const GetUserSkillNudgesQuery = gql`
  query userNudges($userUri: String!) {
    userNudges(userUri: $userUri) {
      id
      skillNudges {
        nudgeId
        categoryName
        categoryUri
        isSkillEnabled
        skillLevel
        skillLevelName
        skillLevelUri
        skillName
        skillUri
      }
    }
  }
`;

export const useUserSkillNudges = ({ userUri, skip }) => {
  const { loading: isUserSkillNudgesLoading, error, data } = useQuery(
    GetUserSkillNudgesQuery,
    {
      variables: {
        userUri
      },
      fetchPolicy: 'cache-and-network',
      skip
    }
  );

  return {
    error,
    userSkillNudges: data?.userNudges?.skillNudges || EMPTY_SKILL_NUDGES,
    isUserSkillNudgesLoading
  };
};

export default useUserSkillNudges;
